<template>
  <div id="hour_idx" @click="close_web">
    <div class="main_con" @click.stop>
      <div class="tit_top relativeItem">
        <div class="close_box absoluteItem" @click="close_web">
          <img class="imgBlock noevents-img" src="../../assets/back.png" />
        </div>
        <div>小时榜规则说明</div>
      </div>
      <div class="scroll_box">
        <div class="top_text">
          <p><span>1.倒计时：</span> 实时展示当前小时内的主播排行情况；</p>
          <p>
            <span>2.排名规则：</span>
            全站所有主播根据当前小时收到的打赏礼物计算魅力值并自动升降排序，小时内魅力值越
            高排名越靠前。每小时结束时刻，榜单清空重新计算，每小时排名前列的主播获得奖励。
          </p>
        </div>
        <!-- 奖励详情 -->
        <p class="t_text">小时榜奖励</p>
        <div class="con_box">
          <p class="tit_p">TOP1</p>
          <ul class="ul_box flex-box">
            <li class="flex-box" v-for="(n, i) in listData01" :key="i">
              <div class="jl_img relativeItem">
                <img
                  class="imgBlock noevents-img absoluteItem centerImg"
                  :src="n.img"
                />
              </div>
              <p class="jl_name">{{ n.gname }}</p>
            </li>
          </ul>
          <div class="bot_text">
            角标系统自行佩戴 <br />
            专属头像框系统自动佩戴该主播可自行选择更换<br />
            热度奖励：接下来一个小时的直播间热度*1.5
          </div>
        </div>
        <div class="con_box">
          <p class="tit_p">TOP2/TOP3</p>
          <ul class="ul_box flex-box">
            <li class="flex-box" v-for="(n, i) in listData02" :key="i">
              <div class="jl_img relativeItem">
                <img
                  class="imgBlock noevents-img absoluteItem centerImg"
                  :src="n.img"
                />
              </div>
              <p class="jl_name">{{ n.gname }}</p>
            </li>
          </ul>
          <div class="bot_text">
            角标系统自行佩戴 <br />
            专属头像框系统自动佩戴该主播可自行选择更换<br />
            热度奖励：接下来一个小时的直播间热度*1.3
          </div>
        </div>
        <div class="con_box">
          <p class="tit_p">TOP4/TOP10</p>
          <ul class="ul_box flex-box ul_last">
            <li class="flex-box" v-for="(n, i) in listData03" :key="i">
              <div class="jl_img relativeItem">
                <img
                  class="imgBlock noevents-img absoluteItem centerImg"
                  :src="n.img"
                />
              </div>
              <p class="jl_name">{{ n.gname }}</p>
            </li>
          </ul>
          <div class="bot_text">
            角标系统自行佩戴 <br />
            热度奖励：接下来一个小时的直播间热度*1.2
          </div>
        </div>
      </div>
    </div>
  </div>
</template>










<script>
export default {
  data() {
    return {
      listData01: [
        { img: require("../../assets/hourtext/top1.png"), gname: "冠军角标" },
        { img: require("../../assets/hourtext/txk.png"), gname: "专属头像框" },
        { img: require("../../assets/hourtext/jl.png"), gname: "热度奖励" },
      ],
      listData02: [
        { img: require("../../assets/hourtext/top10.png"), gname: "角标奖励" },
        { img: require("../../assets/hourtext/txk.png"), gname: "专属头像框" },
        { img: require("../../assets/hourtext/jl.png"), gname: "热度奖励" },
      ],
      listData03: [
        { img: require("../../assets/hourtext/top10.png"), gname: "角标奖励" },
        { img: require("../../assets/hourtext/jl.png"), gname: "热度奖励" },
      ],
    };
  },
  mounted() {
    this.$tool.setTitle("小时榜规则说明");
    this.$appAc.app_refreshUsable(0); //阻止安卓的刷新
  },
  methods: {
    /**关闭webview */
    close_web() {
      this.$appAc.closeWeb();
    },
  },
};
</script>









<style scoped>
#hour_idx {
  width: 100%;
  background: none;
}
.close_box {
  padding: 5px;
  top: 9px;
  left: -14px;
}
.close_box img {
  width: 23px;
  height: 22px;
}
.main_con {
  padding: 0 30px 30px 30px;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  min-height: 68vh;
}
.tit_top {
  width: 100%;
  text-align: center;
  padding: 15px 0;
  font-size: 15px;
  color: #333;
  background-color: #fff;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
}
/* .scroll_box { */
  /* height: calc(68vh - 80px); */
  /* overflow-y: scroll; */
/* } */
.top_text {
  font-size: 0.875rem;
  padding: 6px 0 20px 0;
}
.top_text p {
  text-indent: 2rem;
  color: #707070;
  line-height: 1.5;
}
.top_text p span {
  color: #333;
}
.con_box {
  width: 100%;
  margin-top: 18px;
  border: 1px solid #ff8000;
}
.t_text {
  width: 100%;
  text-align: center;
  font-size: 0.9375rem;
  color: #ff8000;
}
.con_box .tit_p {
  width: 100%;
  text-align: center;
  color: #ff8000;
  font-size: 0.875rem;
  padding: 10px 0;
  border-bottom: 1px solid #ff8000;
}
.ul_box {
  justify-content: space-between;
  border-bottom: 1px solid #ff8000;
}
.ul_box li {
  width: 33.3%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
}

.ul_box li:nth-child(2) .jl_img img,
.ul_box li:nth-child(3) .jl_img img {
  width: 86%;
}
.ul_box li:nth-child(2) {
  border-right: 1px solid #ff8000;
  border-left: 1px solid #ff8000;
}
.con_box .ul_last li {
  width: 50%;
  border: none;
}

.con_box .ul_last li:nth-child(1) {
  border-right: 1px solid #ff8000;
}
.bot_text {
  padding: 8px 12px 8px;
  color: #ff8000;
  font-size: 0.75rem;
  line-height: 1.5;
}
.jl_img {
  width: 3.75rem;
  height: 3.75rem;
  border: 1px solid #ff8000;
  background-color: #ffd5a7;
}
.jl_name {
  padding: 8px 0 0;
  font-size: 0.75rem;
  color: #ff8000;
}
</style>